// extracted by mini-css-extract-plugin
module.exports = {"container":"page_container__1f5hQ","overlay":"page_overlay__3ij-z","inner":"page_inner__3-1Ms","searchWrapper":"page_searchWrapper__1RdJg","loader":"page_loader__3rvmI"};